import { Control, Controller } from 'react-hook-form'
import {
  Box,
  Button,
  FormGroup,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material'
import { OrganizedGroup } from 'interface/login'
import { SelectGroupFormValues } from '../types'

type SelectGroupFormProps = {
  groups: OrganizedGroup[]
  control: Control<SelectGroupFormValues>
  isValid: boolean
  onGroupLogin: () => Promise<void>
  onGroupCancel: () => void
}
export const SelectGroupForm = ({
  groups,
  control,
  isValid,
  onGroupLogin,
  onGroupCancel,
}: SelectGroupFormProps) => {
  return (
    <Box component="form" paddingX={1} noValidate onSubmit={onGroupLogin}>
      <FormGroup>
        <Controller
          control={control}
          name="group"
          render={({ field, formState: { errors } }) => {
            return (
              <>
                <Typography variant='body2' marginBottom={1}>ログイン先グループ</Typography>
                <Select
                  {...field}
                  variant="outlined"
                  size="small"
                  required
                  fullWidth
                  displayEmpty
                  error={!!errors.group}
                  onChange={(e) => field.onChange(Number(e.target.value))}
                  value={field.value}
                >
                  {groups.map((g) => (
                    <MenuItem key={`group-${g.groupId}`} value={g.groupId}>
                      {g.groupName}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )
          }}
        />
      </FormGroup>

      <Stack direction="column" spacing={1} sx={{ mt: 3 }}>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          disabled={!isValid}
        >
          ログイン
        </Button>
        <Button fullWidth variant="outlined" onClick={onGroupCancel}>
          キャンセル
        </Button>
      </Stack>
    </Box>
  )
}
